<template>
  <div class="check-work-body">

    <div class="search-wrap">
      <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="search">搜索</el-button>
    </div>

    <div class="table-wrap">
      <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
        <el-table-column prop="id" label="id" align="center"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="weight" label="排序" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.weight" @change="setFrom(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="setFrom(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="update_time" label="修改时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="内容修改" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
        <el-form-item label="名称" prop="title">
          <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input class="form-input" type="number" v-model="form.weight" value="0" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
            v-model="form.status"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { Loading } from 'element-ui';

export default {
  name: "AppChannel",
  data () {
    return {
      keyword: '',
      loading: false,
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{},
      uploadUrl:""
    }
  },
  created() {
    this.uploadUrl=this.$myhttp.defaults.baseURL+"/admin/OAIndex/uploadFile"
    this.getList()
    console.log(this.uploadUrl)
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    }

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:'',
        weight:'0',
        status:true,
        create_time:'',
        update_time:'',
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      ERP.getRequest({
        url:"admin/OAIndex/getApplicationChannelList",
        data:{keyword: this.keyword, page: this.pageData.page, page_size: this.pageData.pageSize}
      }, res => {
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {

      if(!item) {
        this.form = this.getFormData({})
      } else {
        this.form = item
      }
      this.dialogVisible = true
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          console.log(data)

          ERP.postRequest({
            url:"admin/OAIndex/setApplicationChannel",
            data:data
          }, res => {
            this.$message({type: res.code == 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      ERP.postRequest({
        url:"admin/OAIndex/setApplicationChannel",
        data:data
      }, res => {
        that.$message({type: res.code == 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/AppChannel.vue